import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';

import { ControlMetadata } from 'app/extensibility/metadatas/control/control-metadata';
import { format, stringIsNullOrEmpty } from 'app/shared/utils/string.util';
import { DatasetFormatType } from 'app/model/dataflow/dataset-settings/dataflow-dataset-settings';
import { IDataflowTypeMetadataSource } from 'app/extensibility/metadatas/resource-type/dataflow-format-type-metadata';

const controls: ControlMetadata[] = [
    {
        type: 'parameterizable',
        child: {
            type: 'textbox',
            bind: 'url',
            label: stringResources.ApplicationURL,
            required: true,
            placeholder: format(stringResources.Example, 'https://domain/db/appID'),
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            warningMessageCalculator: (value: string) =>
                stringIsNullOrEmpty(value) ? '' : stringResources.infoSentViaUrlWarning,
            isLabelVertical: true
        },
        warningMessageCalculator: (value: string) =>
            stringIsNullOrEmpty(value) ? '' : stringResources.infoSentViaUrlWarning
    },
    {
        type: 'dynamic-akv-switcher',
        enableAKVParameterization: true,
        hideAKVSwitcherInConnStrProps: true,
        bind: 'userToken',
        label: stringResources.ModelName_Token,
        child: {
            type: 'parameterizable',
            attribute: 'userToken',
            disableAddParameter: true,
            child: {
                type: 'password',
                label: stringResources.ModelName_Token,
                required: true,
                isLabelVertical: true,
                validators: [
                    { type: 'required', errorMessage: '' }
                ]
            }
        },
        description: format(
            stringResources.AzureKeyVaultSecretName_Tooltip_Template,
            format(stringResources.ModelName_LinkedServiceTemplate, stringResources.Quickbase_DisplayText),
            stringResources.ModelName_Token
        )
    }
];

const dataflowQuickbaseSource: IDataflowTypeMetadataSource = {
    type: DatasetFormatType.Quickbase,
    displayName: stringResources.Quickbase_DisplayText,
    settings: adfModelTypeMap.quickbase.dataflowSettings,
    controls: [
        {
            type: 'dataflow-schema-table-selection',
            bind: {
                schemaName: 'schemaName',
                tableName: 'tableName'
            },
            schemaNameLabel: stringResources.ModelName_Table,
            schemaNamePlaceholder: stringResources.DataFlowHiveLinkedServiceRefreshTablePlaceholder,
            tableNameLabel: stringResources.ModelName_Report,
            tableNamePlaceholder: stringResources.DataFlowLinkedServiceSelectSubViewPlaceholder,
            schemaRequired: true,
            selectionType: ['schema', 'table']
        }
    ],
    useInlineProjection: true
};

export const quickbaseMetadata: ILinkedServiceTypeMetadata = {
    type: adfModelTypeMap.quickbase.linkedServiceType,
    displayName: format(stringResources.ModelName_DisplayTextPreviewTemplate, stringResources.Quickbase_DisplayText),
    linkedServiceKind: 'unknown',
    icon: {
        className: 'svg-i-100x100-quickbase'
    },
    category: ['ServicesApps'],
    onlyAzureIR: true,
    copySourceTypes: [],
    copySinkTypes: [],
    isFirstClass: true,
    supportDataFlowSource: true,
    dataflowSource: [dataflowQuickbaseSource],
    supportFirstClassParameterExperience: true,
    controls
};
